import React from 'react';
import { useReveal } from '../lib/useReveal';
const BONUSES = [{
  num: '01',
  title: 'Reiki en 7 Días',
  desc: 'Tu guía de inicio rápido. Primera semana completamente estructurada para empezar a practicar desde el día 1 sin perderte en el camino.',
  value: '$8.000'
}, {
  num: '02',
  title: 'El Mapa de Chakras Aplicado',
  desc: 'El sistema de chakras explicado de forma práctica y visual. Cómo diagnosticar, equilibrar y trabajar cada chakra en tus sesiones reales.',
  value: '$10.000'
}, {
  num: '03',
  title: 'Manual Anti Dudas',
  desc: 'Las 50 preguntas que todo practicante se hace y nadie responde claramente. Tu guía de consulta rápida para cuando no sabés qué hacer.',
  value: '$9.000'
}, {
  num: '04',
  title: 'Protocolos de 10 Minutos',
  desc: 'Sesiones cortas y efectivas para cuando el tiempo es limitado. Protocolos específicos de 10 minutos con resultados reales.',
  value: '$8.000'
}, {
  num: '05',
  title: 'Reiki de Bolsillo',
  desc: 'La guía compacta que siempre llevás con vos. Todo lo esencial del Reiki resumido para consulta rápida en cualquier momento y lugar.',
  value: '$9.000'
}, {
  num: '06',
  title: 'Diario de Práctica 30 Días',
  desc: 'Tu acompañamiento diario durante el primer mes. Registro guiado de cada sesión para que veas tu evolución en tiempo real.',
  value: '$9.000'
}];
export function BonusesSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#0a0a0a] py-12 md:py-16 px-5 sm:px-6 border-t border-white/5 relative overflow-hidden" data-id="element-46">
      <div className="container mx-auto max-w-4xl relative z-10" data-id="element-47">
        <div ref={ref1} className={`reveal text-center mb-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-48">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-3" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-49">
            🎁 6 BONOS INCLUIDOS
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-50">
          {BONUSES.map((bonus, idx) => <div key={idx} className="bg-[#111111] border border-white/5 rounded-xl p-5 flex flex-col h-full" data-id="element-51">
              <div className="flex items-center gap-3 mb-3" data-id="element-52">
                <span className="text-gray-500 font-bold text-xl" data-id="element-53">
                  {bonus.num}
                </span>
                <div className="inline-flex bg-gradient-to-r from-[#eab308] to-[#d4a017] text-[#0f0f1a] text-[10px] font-bold px-2.5 py-1 rounded-full uppercase" data-id="element-54">
                  🎁 BONO {idx + 1}
                </div>
              </div>
              <h3 className="text-lg font-bold text-white mb-2" data-id="element-55">
                {bonus.title}
              </h3>
              <p className="text-gray-400 text-sm leading-relaxed mb-4 flex-grow" data-id="element-56">
                {bonus.desc}
              </p>
              <div className="flex items-center justify-between border-t border-white/10 pt-3 mt-auto" data-id="element-57">
                <span className="text-gray-500 text-xs line-through decoration-red-500/50" data-id="element-58">
                  {bonus.value}
                </span>
                <span className="text-[#eab308] font-bold text-sm uppercase tracking-wider" data-id="element-59">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        <div className="mt-10 text-center" data-id="element-60">
          <p className="text-xl md:text-2xl text-white font-bold" data-id="element-61">
            Valor total bonos:{' '}
            <span className="text-gray-500 line-through" data-id="element-62">$53.000</span>{' '}
            <span className="text-[#eab308]" data-id="element-63">→ GRATIS con tu MegaPack</span>
          </p>
        </div>
      </div>
    </section>;
}